export const GET_META_ADS_CAMPAIGNS = 'GET_META_ADS_CAMPAIGNS';
export const GET_META_ADS_ADSETS = 'GET_META_ADS_ADSETS';
export const GET_META_ADS_ADS = 'GET_META_ADS_ADS';
export const GET_META_ADS_INSIGHTS = 'GET_META_ADS_INSIGHTS';
